import { getRequest } from "../../../api/client";
import { IS_MAINTENANCE_API } from "../../../Endpoints";

export const getIsMaintenance = async () => {
  return getRequest<boolean>(IS_MAINTENANCE_API);
};
